module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "the-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStarted),
      expression: "isStarted"
    }],
    attrs: {
      "type": "checkbox",
      "id": "toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.isStarted) ? _vm._i(_vm.isStarted, null) > -1 : (_vm.isStarted)
    },
    on: {
      "change": _vm.playPause,
      "__c": function($event) {
        var $$a = _vm.isStarted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isStarted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isStarted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isStarted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "toggle"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-night-cont"
  }, [_c('span', {
    staticClass: "the-sun"
  }), _vm._v(" "), _c('div', {
    staticClass: "the-moon"
  }, [_c('span', {
    staticClass: "moon-inside"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch"
  }, [_c('div', {
    staticClass: "button"
  }, [_c('div', {
    staticClass: "b-inside"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-window"
  }, [_c('span', {
    staticClass: "the-sun"
  }), _vm._v(" "), _c('span', {
    staticClass: "the-moon"
  }), _vm._v(" "), _c('div', {
    staticClass: "the-fox"
  }, [_c('div', {
    staticClass: "fox-face"
  }, [_c('section', {
    staticClass: "eyes left"
  }), _vm._v(" "), _c('section', {
    staticClass: "eyes right"
  }), _vm._v(" "), _c('span', {
    staticClass: "nose"
  }), _vm._v(" "), _c('div', {
    staticClass: "white-part"
  }, [_c('span', {
    staticClass: "mouth"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca3860b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sound.vue
// module id = 92
// module chunks = 1